import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DISPLAY_AS_SUMMARY_LIMIT } from '../presenter';
var generateStyle = function generateStyle(componentTheme, props) {
  var shouldDisplayAllItems = props.itemCollection.size <= DISPLAY_AS_SUMMARY_LIMIT;
  var shouldDisplayAsColumn = props.isShowingItems && !shouldDisplayAllItems && !props.sidebarOpen;
  var isSideBarItemHidden = props.isShowingItems && props.sidebarOpen || shouldDisplayAllItems || props.sidebarOpen;
  var isContainerHidden = props.sidebarOpen && !props.isShowingItems && !shouldDisplayAllItems;
  var areItemsHidden = shouldDisplayAllItems || props.isShowingItems;
  var isSummaryHidden = !shouldDisplayAllItems && !props.isShowingItems && !props.sidebarOpen;
  var columnStyles = {
    display: 'flex',
    flexFlow: 'column',
    padding: componentTheme.columnPadding,
    paddingBottom: '0',
    alignItems: 'center'
  };
  var hiddenStyles = {
    display: 'none'
  };
  return {
    column: columnStyles,
    sidebarItemContainer: _objectSpread(_objectSpread({
      display: 'none'
    }, props.sidebarOpen && {
      display: 'block'
    }), (!props.isOver || !props.sidebarOpen) && {
      borderTopStyle: 'dashed',
      borderTopWidth: componentTheme.sidebarIsOpenBottomBorderWidth,
      borderTopColor: componentTheme.sidebarIsOpenBottomBorderColor,
      paddingLeft: '0'
    }),
    sidebarItem: _objectSpread(_objectSpread({
      display: 'block'
    }, shouldDisplayAsColumn && columnStyles), isSideBarItemHidden && hiddenStyles),
    container: _objectSpread({
      display: 'block'
    }, isContainerHidden && hiddenStyles),
    items: _objectSpread({
      display: 'block'
    }, areItemsHidden && hiddenStyles),
    summary: _objectSpread({
      display: 'block'
    }, isSummaryHidden && hiddenStyles)
  };
};
export default generateStyle;